"use client";

import type { FC } from "react";
import { Link2 } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button, Loading } from "@/app/components/ui";

interface ShareDialogFooterProps {
   hasNewerMessages: boolean;
   disabled: boolean;
   isUpdating: boolean;
   isCreating: boolean;
   isCopying: boolean;
   onUpdateLink: () => void;
   onCopyLink: () => void;
}

export const ShareDialogFooter: FC<ShareDialogFooterProps> = ({
   hasNewerMessages,
   disabled,
   isUpdating,
   isCreating,
   isCopying,
   onUpdateLink,
   onCopyLink
}) => {
   const translate = useTranslations("Home");

   return (
      <div className="flex flex-col-reverse gap-3 border-t border-border pt-4 sm:flex-row sm:items-center sm:justify-end">
         {hasNewerMessages && (
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-foreground sm:mr-auto">
               <span>{translate("newMessagesSinceLastShared")}</span>
               <Button
                  variant="link"
                  size="sm"
                  onClick={onUpdateLink}
                  disabled={disabled}
                  className="h-auto p-0 text-sm font-medium"
               >
                  {isUpdating ? <Loading size="sm" /> : translate("updateLink")}
               </Button>
            </div>
         )}
         <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={onCopyLink}
            disabled={disabled}
            className="gap-2 rounded-xl hover:border-primary/40 hover:bg-primary/10 hover:text-primary"
         >
            {isCreating ? <Loading size="sm" /> : <Link2 size={16} />}
            {translate(isCopying ? "copied" : "copyLink")}
         </Button>
      </div>
   );
};
